import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-tts-android' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const TtsAndroid = NativeModules.TtsAndroid
  ? NativeModules.TtsAndroid
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

export function multiply(value: string, uri: string): Promise<string> {
  return TtsAndroid.multiply(value, uri);
}
